import { useEffect } from "react";
import { serializeJsonLd } from "../lib/seo";

const SELECTOR = "script[data-gepeto-jsonld]";

export function useJsonLd(data: unknown[]): void {
  const payload = data.map(serializeJsonLd).join("\n");
  useEffect(() => {
    document.querySelectorAll(SELECTOR).forEach((n) => n.remove());
    const nodes = payload.split("\n").map((json) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-gepeto-jsonld", "");
      s.text = json;
      document.head.appendChild(s);
      return s;
    });
    return () => nodes.forEach((n) => n.remove());
  }, [payload]);
}
